<template>
    <div class="row justify-content-center">
        <div class="col-12 col-md-11 col-lg-10">
            <div class="py-5 px-5 px-md-0">
                <div class="row align-items-center mb-5">
                    <div class="col-md-4 mb-4 mb-md-0">
                        <div class="d-flex align-items-center">
                            <app-media-object
                                    :img-url="$optional(data, 'user', 'profile_picture', 'path')"
                                    :alt-text="$optional(data, 'user', 'full_name')"
                                    :media-title="$optional(data, 'user', 'full_name')"
                                    :media-subtitle="$optional(data, 'user', 'phone')"
                            />
                        </div>
                    </div>
                    <div class="col-md-3 mb-4 mb-md-0">
                        <p class="text-right text-md-left mb-1">
                            <span class="text-muted">{{ $t('email') }}:</span>
                            {{ $optional(data, 'user', 'email') }}
                        </p>
                        <p class="text-right text-md-left mb-1">
                            <span class="text-muted">{{ $t('total_order') }}:</span>
                            {{ $optional(data, 'user', 'orders_count') }}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {numberWithCurrencySymbol} from "../../../Helpers/Helpers";

    export default {
        name: "ExpandableOrderUser",
        props: {
            data: {
                default: function () {
                    return {}
                }
            }
        },
        data() {
            return {
                numberWithCurrencySymbol
            }
        }
    }
</script>

<style scoped>

</style>